<template>
  <v-layout wrap class="custom-header">
    <header-values
      v-for="(item, index) in items"
      :key="index"
      v-bind="item"></header-values>
  </v-layout>
</template>

<script>
import HeaderValues from "@/components/shared/framework/cards/HeaderValues.vue"

export default {
  name: "JoinTeamHeader",
  components: {
    HeaderValues,
  },
  data() {
    return {
      items: [
        {
          layout: "left-side",
        },
        {
          title: "Join Team",
          layout: "middle",
        },
        {
          layout: "right-side img-circle",
          icon: {
            path: this.$store.state.user.profile.imgUrl,
          },
          route: { link: "/profile-info" },
        },
      ],
    }
  },
}
</script>

<style scoped lang="sass"></style>
